export default __webpack_public_path__ + "static/life-grid-yellow-green-min-ac848e4ff12fd2bef33da666f1da400a.png";